define('app/views/templates/helpers/findFirstGolfItemName',['Handlebars'], function (Handlebars) {
    Handlebars.registerHelper('findFirstGolfItemName', function (golfPlayers) {
        for (var i = 0; i < golfPlayers.length; i++) {
          if (golfPlayers[i].ItemName) {
            return golfPlayers[i].ItemName;
          }
        }
      });      
});

